"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityFileField = void 0;
var react_1 = __importDefault(require("react"));
var entity_field_1 = require("./entity-field");
var input_file_upload_1 = require("../components/forms/input-file-upload");
var entityFileField = function (args) {
  var context = args.context,
    maxPreviewWidth = args.maxPreviewWidth,
    onDeriveUrl = args.onDeriveUrl,
    description = args.description;
  var entityData = context.entityData;
  var name = args.name || 'file';
  var fieldSet = args.fieldSet || 'overview';
  return __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    maxPreviewWidth: maxPreviewWidth,
    description: description,
    name: name,
    fieldSet: fieldSet,
    render: function (props) {
      return react_1.default.createElement(input_file_upload_1.InputFileUpload, __assign({
        onDeriveUrl: onDeriveUrl,
        maxPreviewWidth: args.maxPreviewWidth || 200,
        mode: "file"
      }, props));
    },
    metadata: {
      file: entityData && entityData[name]
    }
  });
};
exports.entityFileField = entityFileField;